import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
	Field,
	PdftronComponent,
} from '@components/pdf-modal/pdftron/pdftron.component';
import { ICON } from '@core/util/icon';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { CustomTags } from '@state/global/tags/tags.models';
import { TagsSelector } from '@state/global/tags/tags.selector';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { TestHooks } from './matter-form-viewer.hooks';

@UntilDestroy()
@Component({
	selector: 'app-matter-form-viewer',
	templateUrl: './matter-form-viewer.component.html',
	standalone: false,
})
export class MatterFormViewerComponent implements OnChanges, OnInit {
	testHooks = TestHooks;
	contentBlob: string | Blob;
	customTagsData: CustomTags;
	tags: CustomTags;
	ICON = ICON;

	public _fileName: string;

	@SelectSnapshot(TagsSelector.getTagInjectedDocument) documentParserFn: (
		doc: string,
		customTags: Partial<CustomTags>,
	) => string;
	@Select(TagsSelector.getTags) tags$: Observable<CustomTags>;
	@Select(TagsSelector.getTagInjectedDocument) parsedDocument$: Observable<
		(doc: string) => string
	>;

	@Input() formData: FormData;
	@Input() url: string;
	@Input() fileName: string;
	@Input() expandable: boolean;
	@Input() showCloseButton: boolean = false;

	@Output() finishedRendering: EventEmitter<void> = new EventEmitter<void>();
	@Output() onFieldChanged: EventEmitter<Field> = new EventEmitter<Field>();
	@Output() onReady: EventEmitter<boolean>;
	@Output() selectForm: EventEmitter<string> = new EventEmitter<string>();
	@Output() onClose: EventEmitter<void> = new EventEmitter<void>();

	@ViewChild('pdfViewer', { static: true, read: PdftronComponent })
	pdfViewer: PdftronComponent;

	parsedDocumentSubscription: Subscription;
	constructor(private dialog: MatDialog) {}

	getParsedDocument$(document: string) {
		return this.parsedDocument$.pipe(
			untilDestroyed(this),
			map((_filter) => _filter(document)),
		);
	}

	ngOnInit(): void {
		this.contentBlob = null;
		this.onReady = new EventEmitter<boolean>();
		this.onReady.emit(false);
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.url?.currentValue) {
			this.contentBlob = changes.url.currentValue;
		}
	}

	documentLoaded() {
		this.onReady.emit(true);
	}

	_finishedRendering() {
		this.finishedRendering.emit();
	}

	public fieldChanged(emittedValue: Field): void {
		this.onFieldChanged.emit(emittedValue);
	}

	public async getDocument() {
		return await this.pdfViewer.getDocument();
	}

	public print(): void {
		this.pdfViewer.print();
	}

	public download() {
		this.pdfViewer.download();
	}

	public printInBackground(): void {
		this.pdfViewer.printInBackground();
	}

	public _onClose(): void {
		this.onClose.emit();
	}
}
